<div class="main-section cx-one-ui">
    <div class="form-container cx-one-ui">
        <form id="reporting-set-data-field" *ngIf="showExpression">
            <div class="input-field">
                <label for="formula-field" id="field-formula-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Field_Expression">FIELD EXPRESSION</label> <span class="field-required"> * </span>
                <div class="add-input-field-container">
                    <div class="col-10 add-input-text">
                        <ng-container
                            *ngIf="_numericData?.childs?.length > 0; then addedItem else empty"></ng-container>
                    </div>
                    <ng-container *ngIf="_numericData?.childs.length > 0; then editIcon else addIcon"></ng-container>
                </div>
            </div>
            <div class="input-field">
                <label for="field-type-dropdown" id="operator-type-label" cvLocalizedText
                    langSection="ETL_Reporting_Set" langKey="Function">FUNCTION </label>
                <cxone-singleselect-dropdown id="operator-type-dropdown" [(ngModel)]="_numericData.functionType"
                    [label]="'label'" [isRequired]="true" [primaryKey]="'label'" [placeholder]="functionPlaceholderText"
                    [options]="functionTypes" [showFooter]="showSearch" [sortKey]="'orderId'" sortOrder="'desc'"
                    [search]="showSearch" [ngModelOptions]="{standalone: true}" (selectionChanged)="formValueChanged()">
                </cxone-singleselect-dropdown>
            </div>
        </form>

        <form id="reporting-set-data-field" *ngIf="!showExpression">
            <div class="input-field">
                <label for="field-type-dropdown" id="operator-type-label" cvLocalizedText
                    langSection="ETL_Reporting_Set" langKey="Operation">OPERATION </label><span
                    class="operator-required">
                    * </span>
                <cxone-singleselect-dropdown id="operator-type-dropdown" [(ngModel)]="_numericData.operations"
                    [label]="'label'" [isRequired]="true" [primaryKey]="'label'" [options]="operationTypes"
                    [showFooter]="showSearch" [search]="showSearch" [ngModelOptions]="{standalone: true}"
                    (selectionChanged)="formValueChanged()" [sortKey]="'id'">
                </cxone-singleselect-dropdown>
            </div>
        </form>
    </div>
</div>
<ng-template #addIcon>
    <svg class="add-icon" (click)="addNewField()">
        <use href="../App_Themes/CXone/icons/add.svg#add"></use>
    </svg>
</ng-template>
<ng-template #editIcon>
    <svg class="edit-icon" (click)="editInputClick(_numericData?.childs[0])">
        <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
    </svg>
</ng-template>
<ng-template #addedItem>
    <span class="ellipsis-text" title="{{_numericData.childs[0].name}}">{{_numericData.childs[0].name}}</span>
</ng-template>
<ng-template #empty>
    <span class="text-color" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Input_Field_Placeholder">Add
        input</span>
</ng-template>